import { Main, SYSTEMS_NAMES } from 'services/Analytics/core';

export const initAnalytics = () => {
    Main.initSystems({
        activeSystems: [
            {
                name: SYSTEMS_NAMES.ga,
                id: import.meta.env.GOOGLE_ID,
            },
            {
                name: SYSTEMS_NAMES.ga4,
                id: import.meta.env.GOOGLE_4_ID,
            },
            {
                name: SYSTEMS_NAMES.amazon,
                id: import.meta.env.AMAZON_ID,
                config: {
                    releaseDate: import.meta.env.RELEASE_DATE,
                    streamName: import.meta.env.AWS_DELIVERY_STREAM_NAME,
                    envMode: import.meta.env.ENV,
                },
            },
            {
                name: SYSTEMS_NAMES.amplitude,
                id: import.meta.env.AMPLITUDE_API_KEY,
                config: {
                    releaseDate: import.meta.env.RELEASE_DATE,
                    streamName: import.meta.env.AWS_DELIVERY_STREAM_NAME,
                    envMode: import.meta.env.ENV,
                },
            },
        ],
    });
};
